import md5 from 'js-md5'

export default {
  install: (app, options) => {
    app.config.globalProperties.$md5 = (value) => {
      return md5(value)
    }
  }
}